import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import './styles.scss';

import CardUserInfo from '../CardUserInfo';

const DashboardContent = ({ lastAdmins, totalUsers, totalAdmins, dispoSuiteProjects }) => {
  const { t } = useTranslation();

  return (
    <Row className="main-row-ah">
      <Col className="column-stats-and-admins" md={8}>
        <div className="styled-column-box mb-auto">
          <p className="box-label-title">{t('companyDashboard.indicatorBoxTitle')}</p>
          <div className="indicator-labels-wrapper">
            <div className="p-2 text-center">
              <div className="label-numbers">{totalUsers}</div>
              <span className="label-texts">{t('companyDashboard.professionalUserNumber')}</span>
            </div>
            <div className="p-2 text-center">
              <div className="label-numbers">{totalAdmins}</div>
              <span className="label-texts">{t('companyDashboard.companyAdminsNumber')}</span>
            </div>
            {dispoSuiteProjects > -1 ? (
              <div className="p-2 text-center">
                <div className="label-numbers">{dispoSuiteProjects}</div>
                <span className="label-texts">{t('companyDashboard.dispoSuiteProjects')}</span>
              </div>
            ) : null}
          </div>
        </div>
        <div
          className="styled-column-box"
          style={{
            marginTop: `15px`,
            border: window.innerWidth <= 767 ? 'none' : '',
          }}
        >
          <p className="box-label-title">{t('companyDashboard.boxLastFourAdmins')}</p>
          <div className="cards-wrapper-ah">
            {lastAdmins?.map(userRow => {
              return (
                <CardUserInfo
                  key={userRow.id}
                  firstName={userRow.firstName}
                  lastName={userRow.lastName}
                  address={userRow.address}
                  branchAddress={userRow.branchAddress}
                  email={userRow.email}
                  userFunction={userRow.userFunction}
                  isCompanyAdmin={userRow.isAdmin}
                  pictureSrc={userRow.pictureSrc}
                  styleVariant="dashboard"
                  clientIconUrl={userRow.clientIconUrl}
                  clientIconName={userRow.clientIconName}
                />
              );
            })}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default DashboardContent;
